export default __webpack_public_path__ + "static/media/joe-gardner-2.09841708.jpg";